import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField,  } from "@mui/material";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Backend } from "../../services/Backend";
import ArchiveIcon from '@mui/icons-material/Archive';
import { userHasPermissions } from "../../utils/utils";
import { UserPermissions } from "../../dto/Permissions";
import moment from "moment";

export default function UploadedDocumentsPage() {
    const navigate = useNavigate();
    const [documents, setDocuments] = useState([]);

    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
  
    const [canArchiveDocuments, setCanArchiveDocuments] = useState(false);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    useEffect(() => {
        const fetchData = async () => {
            if (!await userHasPermissions(UserPermissions.SeeUploadedDocuments)) {
                navigate('/');
            }
            setCanArchiveDocuments(await userHasPermissions(UserPermissions.ArchiveDocument));


            Backend.get(`document?page=${page}&owner=true`)
            .then(res => {
                setTotalCount(res.totalCount);
                setDocuments(res.data);
            });
        }

        fetchData();
    }, [page]);

    const goToDocumentPage = (id) => {
        navigate(`/best-practice/${id}`);
    }

    const archiveDocument = async (e, id) => {
        e.stopPropagation();
        await Backend.put(`document/${id}/archive`);

        Backend.get(`document?page=${page}&owner=true`)
            .then(res => {
                setTotalCount(res.totalCount);
                setDocuments(res.data);
            });
    }

    const dearchiveDocument = async (e, id) => {
        e.stopPropagation();

        await Backend.delete(`document/${id}/archive`)
        Backend.get(`document?page=${page}&owner=true`)
            .then(res => {
                setTotalCount(res.totalCount);
                setDocuments(res.data);
            });
    }

    return <div>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow className="bg-slate-950">
                        <TableCell >Id</TableCell>
                        <TableCell >Title</TableCell>
                        <TableCell >Interest</TableCell>
                        <TableCell >Language</TableCell>
                        <TableCell >Publisher</TableCell>
                        <TableCell >Upload date</TableCell>
                        <TableCell >Views</TableCell>
                        <TableCell >Status</TableCell>
                        { canArchiveDocuments ? <TableCell ></TableCell> : "" }
                    </TableRow>
                </TableHead>
                <TableBody>
                {documents.map((row) => (
                    <TableRow key={row.id} onClick={() => goToDocumentPage(row.id)}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell >{row.title}</TableCell>
                        <TableCell >{row.interest}</TableCell>
                        <TableCell >{row.language}</TableCell>
                        <TableCell >{row.publisher}</TableCell>
                        <TableCell width="13%">{moment(row.uploadDate).local().format("YYYY-MM-DD")}</TableCell>
                        <TableCell >{row.views}</TableCell>
                        <TableCell width="10%">{row.isArchived ? "Archived" : "Public"}</TableCell>
                        { canArchiveDocuments ?<TableCell >
                            {row.isArchived ? <ArchiveIcon  className="cursor-pointer" style={{ color: 'red' }} onClick={(e) => dearchiveDocument(e, row.id)}/> 
                            :
                            <ArchiveIcon  className="cursor-pointer" color="primary" onClick={(e) => archiveDocument(e, row.id)} />
                            }
                        </TableCell> : ""}
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={totalCount}
            rowsPerPage={10}
            page={page}
            onPageChange={handleChangePage}
            //   rowsPerPage={rowsPerPage}
            //   page={page}
            //   onPageChange={handleChangePage}
            //   onRowsPerPageChange={handleChangeRowsPerPage}
            />
    </div>
}